import * as React from 'react'

import { cn } from '@/lib/utils'

export interface ValuePropProps {
  icon: React.ReactNode
  title: React.ReactNode
  children: React.ReactNode
  /** Inverts the palette for placement on an ink-dark panel — brand-500 icon, white heading, ink-300 body. */
  onDark?: boolean
  className?: string
}

/**
 * Icon + heading + body, no container. Renamed from the reference's
 * `.vcard` class name — confirmed not a card: it has no border,
 * background, radius, or hover state. The icon is never wrapped in a
 * tinted circle/chip — rendered bare at 24×24, color brand-800.
 */
export function ValueProp({ icon, title, children, onDark = false, className }: ValuePropProps) {
  return (
    <div className={cn('flex flex-col gap-4', className)}>
      <span
        className={cn('block [&_svg]:size-6', onDark ? 'text-brand-500' : 'text-brand-800')}
        aria-hidden="true"
      >
        {icon}
      </span>
      <h3 className={cn('mt-2 text-2xl font-bold tracking-[-0.01em]', onDark && 'text-white')}>{title}</h3>
      <p className={cn('text-md leading-[1.55]', onDark ? 'text-ink-300' : 'text-ink-500')}>{children}</p>
    </div>
  )
}
